/**
 * banner-swiper.js — horizontal scroll-snap carousel of banners.
 *
 * Arrow navigation (shared swiperNav helper) pages the track; drag-to-scroll
 * and native swipe remain. No autoplay — motion is entirely user-driven.
 */
class BannerSwiper extends TRYComponent {
  #ac = null;
  #track = null;

  connectedCallback() {
    super.connectedCallback();
    this.#track = this.querySelector('[data-track]');
    if (!this.#track) return;

    this.#ac = new AbortController();
    const { signal } = this.#ac;

    swiperNav(
      this.#track,
      { prev: this.querySelector('[data-prev]'), next: this.querySelector('[data-next]') },
      signal,
    );
    dragScroll(this.#track, signal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#ac?.abort();
  }
}

customElements.define('banner-swiper', BannerSwiper);
